<script setup>
import AppHeader from './AppHeader.vue';
import { onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import QuoteForm from './QuoteForm.vue';
import router from '@/router';
import { nextTick } from 'process';

const store = useStore();
const route = useRouter();

let focus_me = ref();


watch(
  () => store.state.visible,
  (visible) => {
    if (visible == true) {
      nextTick(()=>{
        focus_me.value.focus();
      })
    } else {
      nextTick(() => {
        document.getElementById('skipNav').focus();
      })
    }
  }
)

onMounted(() => {
  store.commit('updateHeaderText', true);
  //focus_me.href.focus();
  //route.push('/estimate');
});

</script>

<template>
  <div class="app-wrapper" :style="store.state.visible == true ? 'display:unset;visibility:visible;overflow:auto' : 'display:none;visibility:hidden;overflow:auto'"  ref="wrapper">
    <a class="sr-only" aria-label="skip to main content" id="focus" ref="focus_me" href="#main-content">Skip To Main Content</a>
    
    <AppHeader @close="close()"></AppHeader>
  
    <div
    :style="store.state.showHeaderText == true ? 'display:unset;visibility:visible;overflow:hidden' : 'display:none !important;visibility:hidden;overflow:hidden'"
      class="container d-flex flex-column justify-content-center "
      >
      <div class="col-12" id="main-content">
        <h1 class="text-center mb-3">Compression Spring Design & Buy Tool</h1>
      </div>
      <p class="mx-auto text-center" style="max-width: 600px">Our design and buy tool allows you to input sepcifications to receive an instant quote and order online. Enter your spring details below.</p>
      <p class="mx-auto text-center font-weight-bold">Having issues? We're happy to help. <a class="font-weight-bold" target='_blank' href="/contact">Contact Us.</a></p>
    </div>

    <div class="d-flex mt-5" id="app-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

Header {
  margin-bottom: 2.65rem;
}
.app-wrapper {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: white;
  overflow: auto;
  h1 {
    font-size:40px;
    color:#1C5296;
    font-weight: 600;
  }
}



@media screen and (max-width: 500px ) {
  h1 {
    font-size:22px;
  }
  // .app-wrapper {
  //   height: 100% !important;
  //   width: 100% !important;
  // }

}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.button {
  cursor: pointer;
  font-weight: 500;
  left: 3px;
  line-height: inherit;
  position: relative;
  text-decoration: none;
  text-align: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
}

.button--small {
  padding: 10px 20px;
  font-size: 0.875rem;
}

.button--green {
  outline: none;
  background-color: #64d18a;
  border-color: #64d18a;
  color: white;
  transition: all 200ms ease;
}

.button--green:hover {
  background-color: #8bdda8;
  color: white;
}

@media(max-width: 1000px) {
  #app-wrap {
    flex-wrap: wrap;
  }
}
</style>
